import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
  buttonClickedTooltip: {
    id: 'bitkit.copy.buttonClickedTooltip',
    description:
      'Text to display in the tooltip when the copy button is clicked',
    defaultMessage: 'Copied to clipboard',
  },

  buttonTooltip: {
    id: 'bitkit.copy.buttonTooltip',
    description:
      'Text to display in the tooltip when the copy button is not clicked',
    defaultMessage: 'Copy',
  },

  buttonLabel: {
    id: 'bitkit.copy.buttonClickedLabel',
    description: 'Label for the copy button',
    defaultMessage: 'Copy',
  },

  copyableInput: {
    id: 'bitkit.copy.copyableInput',
    description: 'Label for input field that contains text to be copied',
    defaultMessage: 'Copyable input',
  },
});
